import { memo, useMemo } from "react";

import { localizeBreadcrumbUrl } from "@react/utilities/localizeBreadcrumbUrl";

import { BreadcrumbsView } from "./Breadcrumbs.view";
import { BreadcrumbsPlaceholder } from "./BreadcrumbsPlaceholder.view";

interface Props {
  breadcrumbsLabel: string;
  homeLabel: string;
  homeUrl: string;
  isLoading?: boolean;
  items: { title: string; url?: string }[];
}

const BreadcrumbsBase = ({
  breadcrumbsLabel,
  homeLabel,
  homeUrl,
  isLoading = false,
  items,
}: Props) => {
  const updatedItems = useMemo(
    () => [
      { title: homeLabel, url: homeUrl },
      ...items.map((item) => ({
        ...item,
        url: item.url ? localizeBreadcrumbUrl(item.url, homeUrl) : undefined,
      })),
    ],
    [homeLabel, homeUrl, items]
  );
  return isLoading ? (
    <BreadcrumbsPlaceholder />
  ) : (
    <BreadcrumbsView breadcrumbsLabel={breadcrumbsLabel} items={updatedItems} />
  );
};

export const Breadcrumbs = memo(BreadcrumbsBase);
